import angular from 'angular';

import { OfferCardComponent } from './offer-card.component';
import { OfferCardGroupComponent } from './group';
import { PriceComparisonComponent } from './price-comparison';
import { PromoCodeComponent } from './promo-code';
import { PromoMessageComponent } from './promo-message';
import { ProfileLinkComponent } from './profile-link';

export const OfferCardModule = angular
  .module('app.directives.offer-card', [])
  .component('updOfferCard', OfferCardComponent)
  .component('updOfferCardGroup', OfferCardGroupComponent)
  .component('updPromoCode', PromoCodeComponent)
  .component('updPromoMessage', PromoMessageComponent)
  .component('updProfileLink', ProfileLinkComponent)
  .component('updPriceComparison', PriceComparisonComponent);
